import { render, staticRenderFns } from "./CreditStrongLogo.vue?vue&type=template&id=4a4c5f80"
import script from "./CreditStrongLogo.vue?vue&type=script&lang=js"
export * from "./CreditStrongLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports